<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="chevron-down">
<path id="Vector" fill-rule="evenodd" clip-rule="evenodd" d="M3.14645 7.39669C3.34171 7.20143 3.65829 7.20143 3.85355 7.39669L12 15.5431L20.1464 7.39669C20.3417 7.20143 20.6583 7.20143 20.8536 7.39669C21.0488 7.59195 21.0488 7.90854 20.8536 8.1038L12.3536 16.6038C12.1583 16.7991 11.8417 16.7991 11.6464 16.6038L3.14645 8.1038C2.95118 7.90854 2.95118 7.59195 3.14645 7.39669Z" fill="#212328"/>
</g>
</svg>
